module.exports = __webpack_public_path__ + "static/lamb_chicken_comparison-f4dc4f754d41971eb3b57a22754a1ddb.png";